import React, { Component } from 'react';
import {
  faYoutube,
  faInstagram,
  faFacebook,
  faTwitter,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class Homepage extends Component {
  render() {
    return (

      <div>
        <h1>
          Contact
        </h1>
        <h7>
          <p>
            If you'd like to see more of my work please visit my social media pages here:
          </p>
        </h7>
        <h6>
          <ul>
            <li>
              <a
                className="App-link"
                href="https://instagram.com/panku.media/"
                target="_blank"
                rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faInstagram} /> panku.media
              </a>
            </li>
            <li>
              <a
                className="App-link"
                href="https://facebook.com/panku.media/"
                target="_blank"
                rel="noopener noreferrer"
                >
                <FontAwesomeIcon icon={faFacebook} /> panku.media
              </a>
            </li>
            <li>
              <a
                className="App-link"
                href="https://twitter.com/panku_media/"
                target="_blank"
                rel="noopener noreferrer"
                >
                 <FontAwesomeIcon icon={faTwitter} /> panku_media

              </a>
            </li>
            <li>
              <a
                className="App-link"
                href="https://youtube.com/channel/UCUkGSSpiBEtwiE9OQ970P2w"
                target="_blank"
                rel="noopener noreferrer"
                >
                <FontAwesomeIcon icon={faYoutube} /> Panku Media
              </a>
            </li>
          </ul>
        </h6>
        <h7>
          <p>
            And if you'd like to get ahold of me about a photoshoot, a video, or just to talk, send me an email!
          </p>
        </h7>
        <h6>
          <ul>
            <li>
              <a href="mailto:panku.media@gmail.com"><FontAwesomeIcon icon={faEnvelope} />panku.media@gmail.com</a>
            </li>
          </ul>
        </h6>
      </div>

    );
  }
}

export default Homepage;
